import { render, staticRenderFns } from "./reldrecalculado.vue?vue&type=template&id=917f670a&"
import script from "./reldrecalculado.vue?vue&type=script&lang=js&"
export * from "./reldrecalculado.vue?vue&type=script&lang=js&"
import style0 from "./reldrecalculado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports